export default __webpack_public_path__ + "static/media/brocken.d53603e1.svg";